import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import { useTranslation } from 'react-i18next';

const CoachSuccessPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token");
  const subId = new URLSearchParams(window.location.search).get("sub");

  useEffect(() => {
    const subId = new URLSearchParams(window.location.search).get("sub");

    const createUser = async () => {
      await apiFetch("/api/coach/activate", {
        method: "POST",
        body: JSON.stringify({ token, subscriptionId: subId }),
      });
    };

    createUser();
  }, []);

  return (
    <div className="auth-page">
      <button className="btn btn-sm btn-secondary mb-2" onClick={() => navigate('/login')}>
        ← {t('common.back')}
      </button>
      <img src="/dragon-logo.png" alt="DragonFit" className="auth-logo" />
      <h1 className="auth-title neon-text">DragonFit</h1>
      <p className="auth-subtitle">{t('coach_success.coach_panel')}</p>

      <h2 style={{ marginTop: 20 }}>{t('coach_success.activated_title')}</h2>
      <p style={{ marginTop: 10, color: "var(--muted-foreground)", textAlign: "center", maxWidth: "320px" }}>
        {t('coach_success.activated_desc')}
      </p>

      <button
        className="btn btn-primary w-full"
        style={{ marginTop: 24 }}
        onClick={() => navigate("/login")}
      >
        {t('coach_success.go_login')}
      </button>
    </div>
  );
};

export default CoachSuccessPage;
